export default __webpack_public_path__ + "static/media/footer.ae8db84f.png";